/**
 * automatické ošetření sdílecích tlačítek. Použití:
 * $('.js_social-share a[data-social-network]').socialShare();
 *
 * HTML markup
 * <div class="js_social-share">
 *     <a href="javascript:void(0)" data-social-network="twitter"> Sdílet na Twitteru</a>
 * </div>
 *
 * data-social-network: facebook | twitter | linkedin | pinterest
 *
 * na odkaz možno dodat data:
 * data-share-title - vlastní titulek (pokud má být různý od document.title)
 * data-url-share - vlastní URL sdíleného článku, pokud se má lišit od document.URL
 * data-pinterest-image - podstrčení obrázku, který má být připinnován na pinterest
 */

var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "socialShare";

var DEFAULTS = {
	services: {
		facebook: 'https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}',
		twitter:  'https://twitter.com/intent/tweet?text=${title}',
		linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}',
		pinterest: 'https://pinterest.com/pin/create/button/?url=${url}&media=${image}&description=${title}'
	},
	eventSharePerformed: 'SOCIAL_SHARE_PERFORMED'
};

// The actual plugin constructor
function SocialShare(element, options) {
	this.element = element;
	this.$t = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options);
	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;
	this.initialise_();
}

/**
 *
 */
SocialShare.prototype.initialise_ = function() {
	this.type = null;
	this.pageUrl = null;
	this.pageName = null;

	this.getProperties_();
	this.buildShareStrings_();
	this.bindEvents_();
};

SocialShare.prototype.getProperties_ = function() {
	this.type = this.$t.data('socialNetwork');
	this.pageUrl = this.$t.data('urlShare') || String(document.URL);
	this.pageName = this.$t.data('titleShare') || document.title;
	this.imageUrl = this.$t.data('pinterestImage') || '';

	this.pageName = this.pageName.replace('--', '');
};

SocialShare.prototype.buildShareStrings_ = function() {
	this.url = '';
	this.title = '';
	this.image = '';
	var str = '';

	switch (this.type) {
		case 'facebook' :
			this.url = encodeURIComponent(this.pageUrl);
			this.title = encodeURIComponent(this.pageName);
			break;
		case 'twitter':
			str = '';
			str += (this.pageName !== '') ? this.pageName+': ' : '';
			str += this.pageUrl;
			this.title = encodeURIComponent(str);
			break;
		case 'linkedin':
			this.url = encodeURIComponent(this.pageUrl);
			this.title = encodeURIComponent(this.pageName);
			break;
		case 'pinterest':
			this.url = encodeURIComponent(this.pageUrl);
			this.title = encodeURIComponent(this.pageName);
			this.image = encodeURIComponent(window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '') + this.imageUrl); // window.location.origin not used due to IE
			break;
		default:
			break;
	}
};

SocialShare.prototype.bindEvents_ = function() {
	var self_ = this;
	this.$t.on('click', function(e) {
		if (typeof(self_.type) != 'undefined') {
			e.preventDefault();
			$(e.currentTarget).trigger(self_.options.eventSharePerformed, [$(e.currentTarget)]);
			window.open(self_.options.services[self_.type].replace(/\${url}/gi,self_.url).replace(/\${title}/gi,self_.title).replace(/\${image}/gi,self_.image), 'social'+self_.type);
		}
	});
};

/**
 * decide, which methods will be "public"
 */
var API = {
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new SocialShare(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.social-share.js